import React from "react";
import "./Footer.css";

export const Footer = () => {
    return (
        <footer>
            <p>Gabrielle B.</p>
        </footer>
    )
};
